import _objectWithoutProperties from "/vercel/path0/Techattire-admin/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/vercel/path0/Techattire-admin/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["asChild"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Slot as e } from "@radix-ui/react-slot";
import * as r from "react";
import t from "@babel/runtime/helpers/esm/extends";
export var Primitive = ["a", "button", "div", "h2", "h3", "img", "li", "nav", "ol", "p", "span", "svg", "ul"].reduce(function (o, i) {
  return _objectSpread(_objectSpread({}, o), {}, _defineProperty({}, i, /*#__PURE__*/r.forwardRef(function (o, m) {
    var a = o.asChild,
        s = _objectWithoutProperties(o, _excluded),
        n = a ? e : i;

    return r.useEffect(function () {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /*#__PURE__*/r.createElement(n, t({}, s, {
      ref: m
    }));
  })));
}, {});
export var Root = Primitive;